import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { DateRangePickerModalComponent } from './date-range-picker-modal.component';
import { DateRangePickerComponent } from './date-range-picker.component';
import { DateRangePickerService } from './date-range-picker.service';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [DateRangePickerComponent, DateRangePickerModalComponent],
  exports: [DateRangePickerComponent, DateRangePickerModalComponent],
  providers: [DateRangePickerService],
})
export class DateRangePickerModule {}
